module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Lock-circle-aef4d53ef6ce4644bcb42b54603e8aeb.svg";